<template>
	<div v-if="items" id="mapContainer">
		<BaseLocationGoogleMap pin="/images/pin.svg" :locations="items">
			<template v-slot="{item}">
				<div class="infoBox">
					<span class="image" v-if="item.main_image">
						<BaseUiImage :data="item.main_image_thumbs?.['width270-height135-crop1']" loading="lazy" default="/images/no-image-200.jpg" />
					</span>
					<div class="infoBox-cnt">
						<span v-if="item.address" class="address" v-html="item.address" />
						<span v-if="item.business_hour" class="business-hour" v-html="item.business_hour" />
						<span v-if="item.contact" class="contact" v-html="item.contact" />
					</div>
				</div>
			</template>
		</BaseLocationGoogleMap>
	</div>
</template>

<script setup>
	const props = defineProps(['items']);
	let items = props.items;
</script>

<style lang="less" scoped>
	.map{
		height: 550px; 
		:deep(button){min-width: unset; width: unset; height: unset; min-height: unset;}
		:deep(button[title="Close"]) {display: none!important;}
	}
	.infoBox{
		position: relative; width: 290px; background: white; min-height: 170px; padding: 28px 25px 17px 30px; box-shadow: 0 5px 20px 0 rgba(0,0,0,0.2); overflow: initial !important;
		&:before{.pseudo(14px,14px); transform: rotate(45deg); background: white; top: 35px; left: -6px;}
		:deep(img){max-width: 100%; height: auto; display: block; width: auto;}
	}
	.infoBox-cnt{
		display: block;
		:deep(a){text-decoration: none;}
		.title{font-size: 16px; line-height: 22px; font-weight: bold; color: var(--textColor); padding-bottom: 3px; display: block;}
		.address{display: block; color: var(--textColor);}
		.address,.contact{
			font-size: 16px; line-height: 20px; padding-bottom: 13px;
			:deep(p){padding-bottom: 0;font-size: 16px; line-height: 22px;}
		}
		.contact{
			display: block; padding-bottom: 5px; font-size: 15px; line-height: 22px; font-weight: 500;
			:deep(a){display: block; position: relative; cursor: pointer; color: var(--primaryColor); 
				&:first-child{padding-bottom: 5px;}
			}
		}
	}
	:deep(.infoBox-window){
		position: relative; left: 40px; top: -18px;
		.infoBox-close{
			position: absolute; display: flex; align-items: center; justify-content: center; top: 0px; right: 0px; width: 30px; height: 30px; cursor: pointer; z-index: 100; font-size: 0; padding: 9px; background: var(--primaryColor);
			&:before{content: ""; width: 100%; height: 100%; background: url(/media/images/close.svg) no-repeat; background-size: contain;}
		}
	}

	@media (max-width: @t){
		.map{height: 290px;}
		.infoBox{padding: 23px 30px 17px 20px; width: 250px; min-height: 160px;}
		.infoBox-cnt{
			.address,.contact{
				:deep(p){font-size: 13px; line-height: 20px;}
			}
			.contact{
				:deep(a){font-size: 13px !important; line-height: 16px;}
			}
			.address{padding-bottom: 12px;}
		}
	}
	@media (max-width: @m){
		.map{height: 350px;}
	}
</style>
